// extracted by mini-css-extract-plugin
export default {"productCarousel":"p3-z"};